import React from 'react';

import footerLogo from 'styles/assets/png/footer-logo.png';
import bgImage from 'styles/assets/png/login-bg.png';

import classes from 'components/App/AuthPublicPages/components/Layout/Layout.module.scss';

export const Layout = ({ children }) => {
    return (
        <div className={classes.container}>
            <div className={classes.leftSide}>
                <img className={classes.logo} src={footerLogo} alt={'foresight'} />{' '}
                <div className={classes.content}>{children}</div>
            </div>
            <div className={classes.rightSide}>
                <img src={bgImage} alt={'bg image'} className={classes.img} />
            </div>
        </div>
    );
};
